import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import Swal from "sweetalert2";
import { saveFile } from "../../../common/utils/saveFile.util";
import { createDisseminationLessonService } from "../services/createDisseminationLesson.service";
import { updateDisseminationLessonService } from "../services/updateDisseminationLesson.service";
import { deleteDisseminationLessonService } from "../services/deleteDisseminationLesson.service";
import { exportToExcelDisseminationLessonService } from "../services/exportToExceDisseminationLesson.service";
import { exportToPdfDisseminationLessonService } from "../services/exportToPdfDisseminationLesson.service";

const initialState = {
  accident: "",
  lesson: null,
};

export const useDisseminationLessonCommand = (refresh) => {
  const fetchData = useFetch();
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });
  const [loading, setLoading] = useState(false);
  const [disseminationLesson, setDisseminationLesson] = useState(initialState);

  const handleChangeDisseminationLesson = ({ name, value }) => {
    setDisseminationLesson((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const createDisseminationLesson = async (disseminationLesson) => {
    try {
      setLoading(true);
      const isValid = validations(disseminationLesson);
      if (!isValid) return;

      const response = await createDisseminationLessonService(fetchData)(
        disseminationLesson
      );
      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Lección de difusión registrada",
        text: response.message,
      });
      setDisseminationLesson(initialState);
      setErrors({ hasErrors: false, errors: {} });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al registrar la lección de difusión",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = async (filters) => {
    try {
      const response = await exportToExcelDisseminationLessonService(fetchData)(
        filters
      );
      saveFile(response, "lecciones_diseminacion.xlsx");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Ocurrió un error al exportar a Excel",
      });
    }
  };

  const exportToPdf = async (filters) => {
    try {
      const response = await exportToPdfDisseminationLessonService(fetchData)(
        filters
      );
      saveFile(response, "lecciones_diseminacion.pdf");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Ocurrió un error al exportar a PDF",
      });
    }
  }

  const updateDisseminationLesson = async (lesson) => {
    try {
      setLoading(true);
      const response = await updateDisseminationLessonService(fetchData)(lesson);
      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Lección actualizada",
        text: response.message,
      });
      setDisseminationLesson(initialState);
      setErrors({ hasErrors: false, errors: {} });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar la lección",
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteDisseminationLesson = async (id) => {
    try {
      const isSure = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¿Deseas eliminar esta lección de difusión?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!isSure.isConfirmed) return;
      setLoading(true);
      await deleteDisseminationLessonService(fetchData)(id);
      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Eliminado",
        text: "La lección ha sido eliminada exitosamente",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Ocurrió un error al eliminar la lección",
      });
    } finally {
      setLoading(false);
    }
  };

  const validations = (disseminationLesson) => {
    const newErrors = {};

    if (!disseminationLesson.accident) {
      newErrors.accident = "El campo accidente es requerido";
    }

    if (!disseminationLesson.lesson) {
      newErrors.lesson = "El campo lección es requerido";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors({ hasErrors: true, errors: newErrors });
      return false;
    }

    setErrors({ hasErrors: false, errors: {} });
    return true;
  };

  return {
    disseminationLesson,
    handleChangeDisseminationLesson,
    errors,
    createDisseminationLesson,
    updateDisseminationLesson,
    deleteDisseminationLesson,
    exportToExcel,
    exportToPdf,
    loading,
    setDisseminationLesson,
  };
};
